// cmsmodules sliderResponsive  => wenn mehr als 1 Bild hochgeladen, dann wird es als slider angezeigt
 import Splide from '@splidejs/splide';

export class SliderResponsive {
    constructor(content: Element = document.documentElement) {
        const responsiveSliders = content.querySelectorAll('.responsiveSlider');

        if (responsiveSliders.length > 0) {
            responsiveSliders.forEach((responsiveSlider) => {
                this.initializeSlider(responsiveSlider as HTMLElement);
            });
        }
    }


    private initializeSlider(responsiveSlider: HTMLElement): void {
        const id = responsiveSlider.getAttribute('data-slider-id');
        const type = responsiveSlider.getAttribute('data-slider-type');
        const rewind = responsiveSlider.getAttribute('data-slider-rewind');
        const rewindBoolean = (rewind === 'true');
        const autoplayTime = responsiveSlider.getAttribute('data-autoplay-time');
        const autoplay = responsiveSlider.getAttribute('data-autoplay');
        const autoplayBoolean = (autoplay === 'true');

        if (!type || !rewind || !autoplayTime) {
            return;
        }

        const isDialog = responsiveSlider.closest('sl-dialog');
        const sliderID = isDialog
            ? `sl-dialog #cms-slider-${id}.splide`
            : `#cms-slider-${id}.splide`;

        // Entfernt die Klasse 'initialstate', um den Slider sichtbar zu machen
        document.querySelector(sliderID)?.classList.remove('initialstate');

        document.querySelectorAll(sliderID).forEach(slider => {

            if (!slider.classList.contains('is-initialized')) {
                slider.classList.add('is-initialized');

                // Initialisiere Splide-Slider mit den spezifizierten Einstellungen
                new Splide(slider as HTMLElement, {
                    type: type,
                    speed: 500,
                    perPage: 1,
                    perMove: 1,
                    gap: 0,
                    rewind: rewindBoolean,
                    width: '100%',
                    arrows: true,
                    focus: 'center',
                    interval: parseInt(autoplayTime, 10),
                    autoplay: autoplayBoolean,
                    pagination: true,
                    classes: {
                        arrows: 'controls tns-controls',
                        prev: 'splide__arrow--prev controls-prev prev',
                        next: 'splide__arrow--next controls-next next',
                        pagination: 'splide__pagination tns-nav',
                    },
                    breakpoints: {
                        767: {
                            arrows: false
                        },
                    },
                }).on('mounted', () => {
                    //Eye Able Report: ARIA-Wert oder -Attribut nicht unterstuetzt
                    slider.querySelectorAll('.splide__slide[role="group"],.splide__slide[role="button"]').forEach(el => {
                        el.removeAttribute('role');
                    });
                }).mount();
            }
        });


    }
}

